import React from 'react';
import { useLanguage } from '../i18n/LanguageProvider';

function LanguageSwitcher({ compact = false }) {
  const { language, setLanguage } = useLanguage();
  const ariaLabel = language === 'en' ? 'Language switcher' : 'Sélecteur de langue';

  return (
    <div
      className={`language-switcher${compact ? ' compact' : ''}`}
      data-no-i18n="true"
      role="group"
      aria-label={ariaLabel}
    >
      <button
        type="button"
        className={`language-option${language === 'fr' ? ' active' : ''}`}
        aria-pressed={language === 'fr'}
        onClick={() => setLanguage('fr')}
      >
        FR
      </button>
      <button
        type="button"
        className={`language-option${language === 'en' ? ' active' : ''}`}
        aria-pressed={language === 'en'}
        onClick={() => setLanguage('en')}
      >
        EN
      </button>
    </div>
  );
}

export default LanguageSwitcher;
